import { createShader, colorUniform } from "./ShaderBase.js";

export const sunsetShader = createShader({
  customizable: [
    { uniform: "uColorTop", label: "Sky", default: "#1a0a2e" },
    { uniform: "uColorBottom", label: "Horizon", default: "#ff6b35" },
  ],

  uniforms: {
    uPixelSize: { value: 12.0 },
    uScale: { value: 1.0 },
    uSpeed: { value: 0.5 },
    uColorTop: colorUniform("#1a0a2e"),      // Deep purple sky
    uColorBottom: colorUniform("#ff6b35"),   // Warm orange horizon
    uSparkDensity: { value: 0.92 },
    uSparkBrightness: { value: 1.0 },
    uGradientHeight: { value: 8.0 },
  },

  fragmentUniforms: `
    uniform vec3 uColorTop;
    uniform vec3 uColorBottom;
    uniform float uSparkDensity;
    uniform float uSparkBrightness;
    uniform float uGradientHeight;
  `,

  fragmentBody: `
    // World-space vertical gradient (bottom warm orange, top deep purple)
    float normalizedY = (pixelatedPos.y + uGradientHeight * 0.5) / uGradientHeight;
    normalizedY = clamp(normalizedY, 0.0, 1.0);
    vec3 color = mix(uColorBottom, uColorTop, normalizedY);

    // Sparkle noise - subtle twinkling like stars appearing at dusk
    vec3 sparkPos = pixelatedPos * 50.0 + vec3(floor(uTime * uSpeed * 10.0));
    float spark = snoise(sparkPos);

    // Only show sparks on high noise values (sparse single pixels)
    float sparkle = step(uSparkDensity, (spark + 1.0) * 0.5);

    // Add warm golden sparkles
    vec3 sparkColor = vec3(1.0, 0.9, 0.7) * uSparkBrightness;
    color = mix(color, sparkColor, sparkle * 0.6);

    gl_FragColor = vec4(color, 1.0);
  `,
});
